module.exports = __webpack_public_path__ + "static/media/ico_sorting.fd248aec.svg";